import { getRequestHeader } from "h3";
import { MarketCountryCode } from "@backmarket/http-api/src/api-models/MarketCountryCode";
import { getMarketFromDomain } from "../app/utils/getMarketFromDomain.js";
import { MARKET_COUNTRY_CODE } from "../constants.js";
const MARKET_COUNTRY_CODES = new Map(
  Object.values(MarketCountryCode).map((code) => [code.toUpperCase(), code])
);
function parseMarketCountryCode(value) {
  for (const token of value.split(",")) {
    const match = MARKET_COUNTRY_CODES.get(token.trim().toUpperCase());
    if (match) return match;
  }
  return void 0;
}
export function getRequestCountryCode(event) {
  const header = getRequestHeader(event, MARKET_COUNTRY_CODE);
  const fromHeader = header ? parseMarketCountryCode(header) : void 0;
  if (fromHeader) {
    return fromHeader;
  }
  const host = event.node.req.headers.host ?? "";
  const forwardedHost = event.node.req.headers["x-forwarded-host"];
  const devHost = forwardedHost ? String(forwardedHost) : host;
  return getMarketFromDomain(devHost).countryCode;
}
